var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0C141B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5.5 9.167h7.333M9.167 5.5v7.333M11 31.167v5.5M13.75 33.917h-5.5M38.5 22l-6.948-2.794a5.5 5.5 0 0 1-3.05-3.049l-2.815-6.99-2.814 6.99a5.494 5.494 0 0 1-3.05 3.049L12.872 22h-.04l6.949 2.794a5.5 5.5 0 0 1 3.05 3.049l2.815 6.99 2.814-6.99a5.494 5.494 0 0 1 3.05-3.049L38.46 22"
  })));
};
export { SvgStar as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZmMyYWUyZjJmZmNjMmYxYzFkZDBmNzM2YWUxNzMzYmUuc3ZnIjs=";